const varieties = {
  REGISTRATION: 2,
  KEYWORD_CLAIM: 3,
  CHECK_IN: 4,
};

export function getEffortUserGroups(effort) {
  const registrationUserGroup =
    effort.user_groups.find((f) => f.variety === varieties.REGISTRATION) || {};
  const keywordUserGroup =
    effort.user_groups.find((f) => f.variety === varieties.KEYWORD_CLAIM) || {};
  const checkInUserGroup =
    effort.user_groups.find((f) => f.variety === varieties.CHECK_IN) || {};
  return [
    {
      ...registrationUserGroup,
      // title: `Users who registered`,
      user_group_id: registrationUserGroup.id,
      visible: effort.show_registration_user_group,
      variety: varieties.REGISTRATION,
    },
    {
      ...keywordUserGroup,
      // title: `Users who claimed a keyword`,
      user_group_id: keywordUserGroup.id,
      visible: effort.show_keyword_claim_user_group,
      variety: varieties.KEYWORD_CLAIM,
    },
    {
      ...checkInUserGroup,
      // title: `Users who checked in`,
      user_group_id: checkInUserGroup.id,
      visible: effort.show_check_in_user_group,
      variety: 4,
    },
  ]
    .map((m, i) => ({
      ...m,
      title: getEffortUserGroupTitle(m.variety),
      user_id_count: m.user_count,
      description: m.description
        ? m.description
        : m.last_updated_at
        ? `updated ${new Date(m.last_updated_at).toLocaleString()}`
        : "create this group before adding",
    }))
    .filter((f) => f.visible);
}

function getEffortUserGroupTitle(variety) {
  switch (variety) {
    case 2:
      return "Users who registered";
    case 3:
      return "Users who claimed a keyword";
    case 4:
      return "Users who checked in";
  }
}
